module.exports = __webpack_public_path__ + "img/layout-claro.1c451ad7.svg";